// frontend/src/pages/PayrollGuide/components/FaqAccordion.tsx
// One expandable FAQ Q&A row (rendered 6 times in the main page).
// Uses native <details>/<summary> for free keyboard + screen-reader support.

import React from "react";
import { ChevronDown } from "lucide-react";
import type { Faq } from "../types";
import type { SizeConfig } from "../styles";
import { C } from "../styles";

interface FaqAccordionProps {
  faq: Faq;
  sz: SizeConfig;
}

export default function FaqAccordion({
  faq,
  sz,
}: FaqAccordionProps): React.ReactElement {
  return (
    <details
      style={{
        background: "#fff",
        border: "1px solid " + C.line,
        borderRadius: 12,
        marginBottom: 10,
        overflow: "hidden",
      }}
    >
      <summary
        style={{
          cursor: "pointer",
          listStyle: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: sz.faqSummaryPad,
          fontSize: sz.faqSummaryFont,
          fontWeight: 600,
          color: C.ink,
        }}
      >
        {faq.q}
        <ChevronDown size={16} style={{ color: C.muted, flex: "0 0 16px" }} />
      </summary>
      <div
        style={{
          padding: sz.faqAnswerPad,
          fontSize: sz.faqAnswerFont,
          color: C.text,
          lineHeight: 1.6,
          borderTop: "1px solid " + C.lineSoft,
        }}
      >
        {faq.a}
      </div>
    </details>
  );
}